import React, { Component } from 'react';
import { connect } from 'react-redux';
import './bookingDetail.scss';
import Header from "../../../layout/DefaultLayout/Header";
import BackIcon from "../../../images/arrow.png";
import { history } from '../../../helpers';
import ServiceImage from "../../../images/electrician.jpg";
import Avatar from "../../../images/img_avatar.png";

class BookingDetail extends Component {

	constructor(props) {
		super(props);
		this.state = {
			isSuccess: true,
		}
    }
    
    goBack = () => {
        history.goBack();
      }

	render() {
		const { user, formError, formSubmit, userNumber, isSuccess } = this.state;
		return (
            <div>
            <Header></Header>
            {/* <div className="header-container">
               <img onClick={() => { this.goBack() }} src={BackIcon} className="arrow-icon" alt="" />
               <div className="main-heading-txt">Booking Detail</div>
            </div> */}
            <div className="booking-main-container">
            <div className="row">
                    <div className="col-4">
                        <div className="issue-image-box">
                           <img src={ServiceImage} className="issue-image-box" alt="" />
                        </div>
                    </div>
                    <div className="col-8">
                        <div className="service-detail-heading-txt">Booking Date: <span className="service-detail-sub-heading-txt">2020-10-20</span></div>
                        <div className="service-detail-heading-txt">Booking time: <span className="service-detail-sub-heading-txt">12:30PM</span></div>
                        <div className="service-detail-heading-txt">Product Name: <span className="service-detail-sub-heading-txt">Usha</span></div>
                        <div className="service-detail-heading-txt">Modal No: <span className="service-detail-sub-heading-txt">MDD00034234</span></div>
                        <div className="service-detail-heading-txt">Issues: <span className="service-detail-sub-heading-txt">Single Battery Inverter Installation, Double Battery Inverter Installation</span> </div>
                        <div className="service-detail-heading-txt">Description: <span className="service-detail-sub-heading-txt">Lorem Ipsum is simply dummy text of the printing and typesetting industry</span></div>
                        <div className="row list-detail-heading">
                            <div className="col-6">
                                <div className="service-detail-heading-txt">INR 1700 <span className="service-detail-sub-heading-txt">Min Bid Value</span></div>
                               
                            </div>
                            <div className="col-6 service-detail-right">
                               <div className="service-detail-heading-txt">2 <span className="service-detail-sub-heading-txt">Current Bids</span></div>
                               
                            </div>
                        </div>
                        <div className="row card-view">
                            <div className="col-3">
                            <div className="card-avatar-box">
                                <img src={Avatar} className="avatar-image" alt="" />
                                <div className='card-name-text'>Kamal</div>
                            </div>
                            </div>
                            <div className="col-5">
                                <div className='card-heading-sub-text'>500 m Wire: INR 1990</div>
                                <div className='card-heading-sub-text'>Socket: INR 400</div>
                                <div className='card-heading-text'>Total Bid: INR 1300</div>
                                <div className='card-heading-sub-text'>Inverter</div>
                            </div>
                        
                            <div className="col-4">
                                <div className='card-bid-now-btn'>Accpet Bid</div>
                            </div>
                        </div>
                        <div className="row card-view">
                            <div className="col-3">
                            <div className="card-avatar-box">
                                <img src={Avatar} className="avatar-image" alt="" />
                                <div className='card-name-text'>Kundan Jimiwal</div>
                            </div>
                            </div>
                            <div className="col-5">
                                <div className='card-heading-sub-text'>500 m Wire: INR 1990</div>
                                <div className='card-heading-sub-text'>Socket: INR 400</div>
                                <div className='card-heading-text'>Total Bid: INR 1300</div>
                                <div className='card-heading-sub-text'>Inverter</div>
                            </div>
                        
                            <div className="col-4">
                                <div className='card-bid-now-btn'>Accpet Bid</div>
                            </div>
                        </div>
                    </div>
                </div>

               
    
            </div>
			
            </div>
	
		)
	}
}

function mapStateToProps(state) {
	const { user } = state.authentication;
	return {
		user,
	}
}
export default connect(mapStateToProps)(BookingDetail);